/* eslint-disable no-restricted-properties */
import type { sessionStorageTypesKeys } from './types';

export class SessionStorageService {
  get translationWarningDisplayed(): string {
    return sessionStorage.translationWarningDisplayed;
  }

  set translationWarningDisplayed(value: string) {
    sessionStorage.translationWarningDisplayed = value;
  }

  deleteItem(key: sessionStorageTypesKeys) {
    sessionStorage.removeItem(key);
  }

  getItem(key: sessionStorageTypesKeys) {
    return sessionStorage.getItem(key);
  }

  setItem(key: sessionStorageTypesKeys, value: string) {
    sessionStorage.setItem(key, value);
  }
}
